import React from 'react';
import clsx from 'clsx';
import { Handle, Position } from 'react-flow-renderer';
import {
  makeStyles, Typography, Box, SvgIcon
} from '@material-ui/core';

import Card from 'src/components/Card';
import { RefreshCw, Trash2 } from 'react-feather';
import { blue } from '@material-ui/core/colors';
import Node from './Node';
import { IS_FOCUSED, IS_GREYED } from './constants';
import ConfirmationModal from '../../../components/ConfirmationModal';


const useStyles = makeStyles((theme) => ({
  card: {
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    '&:hover $trash': {
      transform: 'scale(1)'
    },
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 50,
  },
  box: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  isGreyed: {
    opacity: 0.5,
  },
}));

const StartProcessNode = ({
  data,
  ...rest
}: any) => {
  const classes = useStyles();
  const isGreyed = data.nodeStyle === IS_GREYED;

  return (
    <Node>
      <Card
        p={1}
        className={clsx({
          [classes.card]: true,
          [classes.isGreyed]: isGreyed,
        })}
        boxProps={{
          className: classes.box
        }}
      >
        <Typography variant="button">{data.label}</Typography>
      </Card>
    </Node>
  );
};

export default StartProcessNode;
